import React, {useEffect} from 'react'
import {useTheme} from '@mui/material/styles'
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  ListItemText,
  OutlinedInput,
  Box,
  TextField,
  ListSubheader,
} from '@mui/material'
import Autocomplete from '@mui/material/Autocomplete'
import LanguageTranslations from '../../utils/textConst'

const LanguageSelector = ({value, onChange}) => {
  const [searchTerm, setSearchTerm] = React.useState('')
  const theme = useTheme()

  const handleChange = event => {
    var lang = event.target.value
    if (lang) {
      onChange && onChange(lang.code, lang.direction || 'ltr')
    }
  }

  useEffect(() => {
    if (value === null || value.length === 0) {
      let lang = LanguageTranslations.translations['en']
      onChange && onChange(lang.code, lang.direction)
    }
  }, [])
  return (
    <>
      <FormControl fullWidth variant="outlined" sx={{mb: 2, width: 180}}>
        {/* <InputLabel id="language-selector-label">Languages</InputLabel> */}
        <InputLabel
          id="language-selector-label"
          sx={
            {
              //color: theme.palette.mode === 'dark' ? theme.palette.grey[100] : theme.palette.text.primary,
            }
          }
        >
          Languages
        </InputLabel>
        <Select
          size="small"
          onClick={e => {
            e.stopPropagation()
            e.preventDefault()
          }}
          labelId="language-selector-label"
          fullWidth
          value={value}
          onChange={handleChange}
          autoComplete="off"
          label="Languages"
          multiple={false}
          MenuProps={{
            PaperProps: {
              style: {
                maxHeight: 500,
              },
            },

            disableScrollLock: true,
          }}
          input={<OutlinedInput label="Languages" />}
          renderValue={selected => {
            if (selected === null || selected === '') {
              return 'Select Language'
            }
            let lang = LanguageTranslations.translations[selected]
            return (
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  flex: 'space-between',
                }}
              >
                <img
                  src={lang?.flag}
                  alt={lang?.name}
                  width="24"
                  height="18"
                  className="language-flag"
                />
                {lang?.name}
              </Box>
            )
          }}
        >
          <MenuItem
            value=""
            onClickCapture={e => {
              e.stopPropagation()
              e.preventDefault()
            }}
            onKeyDown={e => e.stopPropagation()}
            className="language-selector"
          >
            <TextField
              label="Search Language..."
              value={searchTerm}
              autoFocus
              size="small"
              onChange={e => {
                setSearchTerm(e.target.value)
              }}
              sx={{my: 1, width: '100%'}}
            ></TextField>
          </MenuItem>
          {[
            ...LanguageTranslations.codes(
              searchTerm === '' || searchTerm === null
            ),
          ]?.map(code => {
            let lang = LanguageTranslations.getLanguage(code)
            if (
              (searchTerm &&
                !lang?.name.toLowerCase().includes(searchTerm.toLowerCase())) ||
              lang === null
            ) {
              return null
            }
            return (
              <MenuItem key={lang} value={lang} className="language-selector">
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    flex: 'space-between',

                    direction: value.direction,
                  }}
                >
                  {lang?.flag && (
                    <img
                      src={lang?.flag}
                      alt=""
                      width="20"
                      height="15"
                      style={{
                        direction: lang.direction,
                        marginRight: 10,
                      }}
                    />
                  )}
                  <ListItemText
                    className="country-names"
                    primary={lang?.name}
                  />
                </Box>
              </MenuItem>
            )
          })}
        </Select>
      </FormControl>
    </>
  )
}

export default LanguageSelector
